import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Utility } from '../shared/utility/utility';
import * as _ from 'underscore';
import { Router, NavigationEnd } from '@angular/router';
import { BannerService } from '../services/banner.service';
import { AjaxService } from '../services/ajax.service'
import { UserDetailsService } from '../services/user-details.service';
import { EmitterService } from '../services/emitter.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { EnvironmentService } from '../shared/services/environment.services';
@Component({
  selector: 'app-shotfooter',
  templateUrl: './app-shotfooter.component.html',
  styleUrls: ['./app-shotfooter.component.scss']
})
export class AppShotfooterComponent implements OnInit, AfterViewInit, OnDestroy {
  windowType;
  isUserLoggedIn: boolean;
  langCode: any;
  currentURL_slug;
  translates;
  mappedLanguageCodes;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private utils: Utility,
    private router: Router,
    private bannerService: BannerService,
    private ajaxService: AjaxService,
    private userDetailsService: UserDetailsService,
    private emitterService: EmitterService,
    private translate: TranslateService,
    private environmentService:EnvironmentService
  ) {
    
    this.mappedLanguageCodes = this.environmentService.getActiveLanguageConfig();
  }

  ngOnInit() {
    this.translates = this.translate;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const ww = document.body.clientWidth;
      if (ww <= 767) {
        this.windowType = "mobile";
      }else{
        this.windowType = "device";
      }
    });
  }

   
  listClick(event, item) {
    event.preventDefault();
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    let lang = window.location.pathname.substring(1, 3);
    this.langCode = item;
    this.currentURL_slug = window.location.pathname.substring(3);
    if (item && item !== localStorage.getItem("langCode")) {
      this.langCode = item;
      this.bannerService.clearBanners();
      localStorage.setItem("langCode", this.langCode);
      this.emitterService.broadcastLangCode(this.langCode);
      this.router.navigate([this.langCode])
      if (this.isUserLoggedIn) {
        Promise.resolve(this.userDetailsService.checkUserProfile()).then(
          (completeUserStatus) => {
            let userDetail = this.userDetailsService.getUserProfileDetails();
            this.utils.updateProfileLangCode(userDetail,completeUserStatus);
          })
      } else if (!this.isUserLoggedIn) {
        this.utils.reloadPage();
      }
    }
  }
 
  
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
